import React from 'react'
import { useTranslation } from 'react-i18next';
import pdf from '../Images/pdfdownload.svg'
import Loading from './loader/loader';
import { Link } from 'react-router-dom';

const LawCodesSearch = ({
    title,
    search,
    setSearch,
    handleSearchClick,
    recommendations,
    recommendationLoading,
    showRecommendations,
    handleKeyDown
}) => {
    const { t, i18n } = useTranslation();

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    const getPdfUrl = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    return (
        <div className='md:flex justify-between mb-8 '>
            <p className='text-primary text-xl font-bold
                          dark:text-dark-text'>
                {title}
            </p>
            <div className='mt-4 md:mt-0 md:w-[40%] relative'>
                <div className='flex justify-center'>
                    <input
                        type="search"
                        placeholder={t('search')}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className='border border-border dark:border-dark-border
                               p-2 focus:outline-none focus:ring-2 
                               focus:ring-indigo-500 dark:text-white
                               transition duration-150 ease-in-out w-full
                               shadow-inner dark:bg-dark-box xl:rounded-l-md'
                    />
                    <button
                        onClick={handleSearchClick}
                        className='p-2 bg-primary text-white rounded-r-md 
                                 transition duration-150 ease-in-out 
                                 focus:outline-none 
                                 focus:ring-2 focus:ring-indigo-500'
                    >
                        {t('search')}
                    </button>
                </div>
                {showRecommendations && recommendations?.length > 0 &&
                    <ul className='bg-white rounded-b-md shadow-lg border border-secondary
                                   dark:border-none dark:bg-dark-box max-h-[300px] w-full
                                   overflow-y-scroll absolute mt-[-3px] z-[1]'>
                        {recommendationLoading ? (
                            <Loading />) : <>
                            <li className='p-2 flex justify-between dark:text-white bg-gray
                                       border-b border-b-border dark:bg-dark-box dark:border-b
                                       dark:border-b-border'>
                                {t('search_result')}
                                <p>{recommendations?.length}</p>
                            </li>
                            {recommendations?.map((r) => (
                                <li className='p-2 flex justify-between border-b border-b-secondary 
                                    w-full items-center dark:border-b-dark-box dark:text-dark-text'>
                                    <Link to={`/laws/${r.id}`} className='w-[90%]'>
                                        <p>
                                            {getLawName(r)}
                                        </p>
                                    </Link>
                                    <a
                                        href={getPdfUrl(r)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='flex justify-end w-6 h-6'
                                    >
                                        <img src={pdf} alt="PDF" className='w-full h-full' />
                                    </a>
                                </li>
                            ))}
                            {recommendations?.length >= 10 &&
                                <li
                                    onClick={handleSearchClick}
                                    className='w-full p-2 bg-blue dark:text-dark-text
                                            cursor-pointer text-center dark:bg-dark-border'>
                                    {t('view_all')}
                                </li>
                            }
                        </>}
                    </ul>
                }
            </div>
        </div>
    )
}

export default LawCodesSearch